import { useState ,useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import CurrencyDisplay from '../components/CurrencyDisplay';
import styles from '../styles/orderconfirmed.module.css'
import api from '../api/axios';

const OrderConfirmed = () => {
    const { user } = useContext(UserContext);
    const [order, setOrder] = useState([]);

    const fetchOrder = async () => {
        try {
            const res = await api.get('/order/user');
            const orders = res.data.orders || [];
            setOrder(orders[0]);
        } catch (error) {
            console.error('Error fetching order', error);
        }
    };

    useEffect(() => {
        fetchOrder();
    }, []);

    console.log(order)
    
    return (
        <div className={styles.mainConfirm}>
            <div className={styles.orderConfirmation}>
                <div className={styles.message}>
                    <h1>Order Confirmation</h1>
                    <p className={styles.number}>#{order.id}</p>
                    <div className={styles.line}></div>
                    <p>
                        Please see your order confirmation below.
                        Thank you for your business! We will send you a receipt once
                        we have received the funds.<br/><br/>
                        Please send funds to: billing@thewetlandshop.ca
                    </p>
                </div>
            </div>
            <div className={styles.confirmation}>
                <div className={styles.where}>
                    <p className={styles.label}>Where</p>
                    <div className={styles.content}>
                    <p className={styles.shipping}>{order.shipping_address}</p>
                    </div>
                </div>
                <div className={styles.what}>
                    <p className={styles.label}>What</p>
                    <div className={styles.content}>
                        {Array.isArray(order.items) && order.items.map(item => (
                            <div key={item.product_id} className={styles.items}>
                                <div className={styles.mainInfo}>
                                    <p><span>{item.title}</span></p>
                                    <p className={styles.material}>{item.material}</p>
                                </div>
                                
                                <p>Qty: {item.quantity}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={styles.howmuch}>
                    <p className={styles.label}>How much</p>
                    <div className={styles.content}>
                        <p>Subtotal: {<CurrencyDisplay amount={order.total} currency='CAD' />}</p>
                        <p>Taxes: {<CurrencyDisplay amount={order.taxes} currency='CAD'/>}</p>
                        <p>Total: {<CurrencyDisplay amount={order.total + order.taxes} currency='CAD'/>}</p>
                    </div>
                </div>
            </div>
            <div className={styles.goback}>
                <NavLink to='/'><button>Return home</button></NavLink>
            </div>
        </div>
    );
};

export default OrderConfirmed;